'use strict';

var React = require('react');
var index_es = require('./index.es-8c72aff8.js');
var OnceStart = require('./OnceStart-83973221.js');
var WidgetController_widgets_GridWidgetLayout_RestaurantCard_type = require('./WidgetController/widgets/GridWidgetLayout/RestaurantCard/type.js');
var styled = require('styled-components');
var Image = require('@swiggy-private/dls-web-core/dist/components/Image');
var Text = require('@swiggy-private/dls-web-core/dist/components/Text');
var WidgetControllerContext = require('./WidgetControllerContext-924d4968.js');
var Button = require('@swiggy-private/dls-web-core/dist/components/Button');
var index_es$1 = require('./index.es-55fa6858.js');
var GenericIconWeb = require('@swiggy-private/dls-web-icons/dist/GenericIconWeb');
var infoFilled = require('@swiggy-private/dls-web-icons/dist/web/generic/infoFilled');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const ImageContainer = styled__default['default'](Image.Image)(({ theme }) => ({
    borderRadius: theme.spacing.medium,
}));
const ButtonContainer = styled__default['default'].div(({ theme }) => ({
    margin: `0 ${theme.spacing.xLarge}`,
}));
const ButtonContainerDOandFood = styled__default['default'].div(({ theme }) => ({
    margin: `0 ${theme.spacing.xLarge}`,
    display: "grid",
    gridAutoFlow: "column",
    gridGap: theme.spacing.small,
    gridAutoColumns: "1fr",
}));
const Container = styled__default['default'].div(({ theme, hasExtraLine }) => ({
    background: theme.colors[theme.colorMode].background_Primary,
    paddingBottom: theme.spacing.xLarge,
    paddingTop: theme.spacing.large,
    borderRadius: theme.cornerRadius.medium,
    zIndex: theme.elevation[theme.colorMode].cards_And_Navigations.zIndex,
    height: `calc(126vw + 44px + ${theme.spacing.xLarge} + ${theme.spacing.large} + ${hasExtraLine ? "36px" : "0px"})`,
    contain: "content",
    containIntrinsicHeight: `calc(126vw + 44px + ${theme.spacing.xLarge} + ${theme.spacing.large} + ${hasExtraLine ? "36px" : "0px"})`,
}));
const TextContainer = styled__default['default'].div(({ theme }) => ({
    margin: `0 ${theme.spacing.xLarge} ${theme.spacing.small} ${theme.spacing.xLarge}`,
    display: "flex",
    alignItems: "center",
}));
const TextStyled = styled__default['default'](Text.Text)(({ theme }) => ({
    marginLeft: theme.spacing.xxSmall,
}));

const TEXTS = {
    ORDER_NOW: "Order Now",
    VIEW_MENU: "View Menu",
    DINEOUT: "Dineout",
    DELIVERY_UNAVAILABLE: "Outlet currently unavailable for delivery",
    DELIVERY_UNSERVICEABLE: "Outlet currently unavailable for delivery",
};
const IMAGE_ID = `l_text:Roboto_40_medium:{0},g_north_west,x_434,y_216,co_rgb:808080/l_text:Roboto_40_regular:{1},g_north_west,x_384,y_148,co_rgb:808080/{2}`;
const DEEPLINKS = {
    FOOD: `swiggy://menu?restaurant_id={0}`,
    CLOSED_FOOD: `swiggy://menu?restaurant_id={0}&openCollections=true`,
    DINEOUT: `swiggydiners://details/{0}?isNativeNavigated=true`,
};

function isUnServiceable(restaurant) {
    if (restaurant.sla) {
        return restaurant.sla.serviceability !== WidgetController_widgets_GridWidgetLayout_RestaurantCard_type.SERVICEABILITY_TYPES.SERVICEABLE;
    }
    return restaurant.unserviceable || false;
}
function isRestaurantClosed(restaurant, checkForUnserviceable = true) {
    if (checkForUnserviceable && isUnServiceable(restaurant)) {
        return true;
    }
    if (restaurant.availability !== undefined) {
        return !restaurant.availability.opened;
    }
    return restaurant.opened !== 1 || restaurant.tmpClosed || true;
}
const getAverageRatingStringForCloudinary = (restaurantCard) => {
    let avgString = restaurantCard.avgRatingString || "";
    avgString += restaurantCard.totalRatingsString ? ` (${restaurantCard.totalRatingsString})` : "";
    return encodeURIComponent(avgString);
};
const getAreaNameForCloudinary = (restaurantCard) => {
    if (index_es.N(restaurantCard.areaName)) {
        return undefined;
    }
    const shortenAreaName = `${restaurantCard.areaName.slice(0, 22)}${restaurantCard.areaName.length > 22 ? "..." : ""}`;
    return encodeURIComponent(shortenAreaName);
};
const getCloudinaryImageID = (restaurantCard) => {
    const { cloudinaryImageId } = restaurantCard;
    if (index_es.N(cloudinaryImageId)) {
        return "";
    }
    const avgRating = getAverageRatingStringForCloudinary(restaurantCard);
    const areaName = getAreaNameForCloudinary(restaurantCard);
    if (!index_es.N(avgRating) && !index_es.N(areaName)) {
        if (avgRating.includes("--")) {
            return index_es.O(IMAGE_ID, "NEW", areaName, cloudinaryImageId);
        }
        return index_es.O(IMAGE_ID, avgRating, areaName, cloudinaryImageId);
    }
    return cloudinaryImageId || "";
};

const ButtonComponent = ({ widgetType, restaurantCard, analyticsVal }) => {
    const { sdk, clickAnalytics } = React.useContext(WidgetControllerContext.WidgetControllerContext);
    const isRestClosed = React.useMemo(() => isRestaurantClosed(restaurantCard), [restaurantCard]);
    const onFoodClick = React.useCallback(() => {
        if (!index_es.N(clickAnalytics)) {
            clickAnalytics({
                action: "click-restaurant",
                value: analyticsVal === null || analyticsVal === void 0 ? void 0 : analyticsVal.cardPosition,
                label: restaurantCard.id,
                context: {
                    cta: isRestClosed ? TEXTS.VIEW_MENU : TEXTS.ORDER_NOW,
                    widgetId: analyticsVal === null || analyticsVal === void 0 ? void 0 : analyticsVal.widgetId,
                    property_id: analyticsVal === null || analyticsVal === void 0 ? void 0 : analyticsVal.collectionId,
                    widget_vpos: analyticsVal === null || analyticsVal === void 0 ? void 0 : analyticsVal.widgetPosition,
                    dataprovider_identifier: analyticsVal === null || analyticsVal === void 0 ? void 0 : analyticsVal.theme,
                },
            });
        }
        const navigateData = {
            type: index_es$1.N.DEEPLINK,
            link: index_es.O(isRestClosed ? DEEPLINKS.CLOSED_FOOD : DEEPLINKS.FOOD, restaurantCard.id),
        };
        sdk === null || sdk === void 0 ? void 0 : sdk.navigateToScreen(navigateData).catch(() => undefined);
    }, [analyticsVal, clickAnalytics, restaurantCard.id, sdk, isRestClosed]);
    const onDineoutClick = React.useCallback(() => {
        if (!index_es.N(clickAnalytics)) {
            clickAnalytics({
                action: "click-restaurant",
                value: analyticsVal === null || analyticsVal === void 0 ? void 0 : analyticsVal.cardPosition,
                label: restaurantCard.id,
                context: {
                    cta: TEXTS.DINEOUT,
                    widgetId: analyticsVal === null || analyticsVal === void 0 ? void 0 : analyticsVal.widgetId,
                    property_id: analyticsVal === null || analyticsVal === void 0 ? void 0 : analyticsVal.collectionId,
                    widget_vpos: analyticsVal === null || analyticsVal === void 0 ? void 0 : analyticsVal.widgetPosition,
                    dataprovider_identifier: analyticsVal === null || analyticsVal === void 0 ? void 0 : analyticsVal.theme,
                },
            });
        }
        const navigateData = {
            type: index_es$1.N.DEEPLINK,
            link: index_es.O(DEEPLINKS.DINEOUT, restaurantCard.id),
        };
        sdk === null || sdk === void 0 ? void 0 : sdk.navigateToScreen(navigateData).catch(() => undefined);
    }, [analyticsVal, clickAnalytics, restaurantCard.id, sdk]);
    switch (widgetType) {
        case WidgetController_widgets_GridWidgetLayout_RestaurantCard_type.RestaurantTypes.FOOD:
            return (React__default['default'].createElement(React__default['default'].Fragment, null,
                isRestClosed ? (React__default['default'].createElement(TextContainer, null,
                    React__default['default'].createElement(GenericIconWeb.GenericIcon, { Icon: infoFilled.Svg16, fillColor: "highlight", strokeColor: "highlight" }),
                    React__default['default'].createElement(TextStyled, { variant: "body_B3_Med", color: "highlight" }, TEXTS.DELIVERY_UNSERVICEABLE))) : null,
                React__default['default'].createElement(ButtonContainer, null,
                    React__default['default'].createElement(Button.Button, { variant: "primary", onClick: onFoodClick, buttonSize: "small" }, isRestClosed ? TEXTS.VIEW_MENU : TEXTS.ORDER_NOW))));
        case WidgetController_widgets_GridWidgetLayout_RestaurantCard_type.RestaurantTypes.DINEOUT:
            return (React__default['default'].createElement(React__default['default'].Fragment, null,
                React__default['default'].createElement(TextContainer, null,
                    React__default['default'].createElement(GenericIconWeb.GenericIcon, { Icon: infoFilled.Svg16, fillColor: "highlight", strokeColor: "highlight" }),
                    React__default['default'].createElement(TextStyled, { variant: "body_B3_Med", color: "highlight" }, TEXTS.DELIVERY_UNAVAILABLE)),
                React__default['default'].createElement(ButtonContainer, null,
                    React__default['default'].createElement(Button.Button, { variant: "primary", onClick: onDineoutClick, buttonSize: "small" }, TEXTS.DINEOUT))));
        case WidgetController_widgets_GridWidgetLayout_RestaurantCard_type.RestaurantTypes.DINEOUT_AND_FOOD:
            return (React__default['default'].createElement(React__default['default'].Fragment, null,
                isRestClosed ? (React__default['default'].createElement(TextContainer, null,
                    React__default['default'].createElement(GenericIconWeb.GenericIcon, { Icon: infoFilled.Svg16, fillColor: "highlight", strokeColor: "highlight" }),
                    React__default['default'].createElement(TextStyled, { variant: "body_B3_Med", color: "highlight" }, TEXTS.DELIVERY_UNSERVICEABLE))) : null,
                React__default['default'].createElement(ButtonContainerDOandFood, null,
                    React__default['default'].createElement(Button.Button, { variant: "secondary", onClick: onDineoutClick, buttonSize: "small" }, TEXTS.DINEOUT),
                    React__default['default'].createElement(Button.Button, { variant: "primary", onClick: onFoodClick, buttonSize: "small" }, isRestClosed ? TEXTS.VIEW_MENU : TEXTS.ORDER_NOW))));
        default:
            return null;
    }
};
var ButtonComponent$1 = React__default['default'].memo(ButtonComponent);

const width = 323;
const RestaurantCard = ({ widgetType, restaurantCard, analyticsVal }) => {
    const { impressionAnalytics } = React.useContext(WidgetControllerContext.WidgetControllerContext);
    const impressionRestaurant = React.useCallback(() => {
        if (!index_es.N(impressionAnalytics)) {
            impressionAnalytics({
                action: "impression-restaurant",
                value: analyticsVal === null || analyticsVal === void 0 ? void 0 : analyticsVal.cardPosition,
                label: restaurantCard.id,
                context: {
                    widgetId: analyticsVal === null || analyticsVal === void 0 ? void 0 : analyticsVal.widgetId,
                    property_id: analyticsVal === null || analyticsVal === void 0 ? void 0 : analyticsVal.collectionId,
                    widget_vpos: analyticsVal === null || analyticsVal === void 0 ? void 0 : analyticsVal.widgetPosition,
                    dataprovider_identifier: analyticsVal === null || analyticsVal === void 0 ? void 0 : analyticsVal.theme,
                },
            });
        }
    }, [impressionAnalytics, restaurantCard.id, analyticsVal]);
    if (index_es.N(restaurantCard)) {
        return null;
    }
    const cloudinaryImageId = getCloudinaryImageID(restaurantCard);
    return (React__default['default'].createElement(OnceStart.ElementObserver, { onViewEnter: impressionRestaurant },
        React__default['default'].createElement(Container, { hasExtraLine: isRestaurantClosed(restaurantCard) || widgetType === WidgetController_widgets_GridWidgetLayout_RestaurantCard_type.RestaurantTypes.DINEOUT },
            React__default['default'].createElement(ImageContainer, { src: index_es.D(cloudinaryImageId, {
                    width: width * 3,
                    keepExtension: true,
                }, {
                    useImageKit: true,
                    teamLine: index_es.n.PORTAL,
                }), fit: "initial", height: "126vw", background: "background_Primary" }),
            React__default['default'].createElement(ButtonComponent$1, { widgetType: widgetType, restaurantCard: restaurantCard, analyticsVal: analyticsVal }))));
};
var RestaurantCard$1 = React__default['default'].memo(RestaurantCard);

const getRestaurantCards = ({ widgetType, restaurants, analyticsVal, containerPadding, }) => {
    return restaurants === null || restaurants === void 0 ? void 0 : restaurants.map((restaurant, index) => {
        analyticsVal = Object.assign(Object.assign({}, analyticsVal), { cardPosition: index + 1 });
        return (React__default['default'].createElement(RestaurantCard$1, { widgetType: widgetType, restaurantCard: restaurant.info, analytics: restaurant.analytics, analyticsVal: analyticsVal, containerPadding: containerPadding }));
    });
};

exports.getRestaurantCards = getRestaurantCards;
//# sourceMappingURL=RestaurantRenderer-b1b439d1.js.map
